import { render, staticRenderFns } from "./SignInH5.vue?vue&type=template&id=2041cfe3&scoped=true&"
import script from "./SignInH5.vue?vue&type=script&lang=js&"
export * from "./SignInH5.vue?vue&type=script&lang=js&"
import style0 from "./SignInH5.vue?vue&type=style&index=0&id=2041cfe3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041cfe3",
  null
  
)

export default component.exports